
import { useGet } from '@ngt/opms';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetLocales, Locale } from '../../api/dtos';


const request = () =>  new GetLocales();

const getData = (response?: SWRResponse<Locale[], Locale[]>) => response?.data;
const getError = (response?: SWRResponse<Locale[], Locale[]>) => ((response?.error ?? response?.data) as any)?.responseStatus;

export const useLocales = (configuration?: SWRConfiguration) => {

    return useGet(request, { getData, getError}, configuration);
};

export default useLocales;
